import { BenefitProducts } from "../entities/BenefitProducts";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}product-benefits`;

export const fetchBenefitProducts = async (): Promise<BenefitProducts[]> => {
  const response = await axios.get(API_URL); // Use axios to make the GET request.
  const data = response.data.data; // Access the nested 'data' array.
  
  // Map the response to BenefitProducts instances.
  return data.map((item: any) => new BenefitProducts(item.id, item.title, item.description, item.icon));
};